declare const gon: { currentUser?: { id: string } } | undefined

/**
 * Parse participant IDs from a filter's participants key.
 * The participants key format is sorted user IDs joined by underscore: "id1_id2"
 *
 * @param filter - The filter object containing a participants key
 * @param excludeCurrentUser - Whether to filter out the current user (default: true)
 * @returns Array of participant user IDs
 */
export function getParticipantIdsFromFilter(
    filter: { participants?: string } | null | undefined,
    excludeCurrentUser: boolean = true,
): string[] {
    if (!filter?.participants) {
        return []
    }

    const ids = filter.participants.split('_')

    if (excludeCurrentUser && typeof gon !== 'undefined' && gon?.currentUser?.id) {
        return ids.filter(id => id !== gon.currentUser!.id)
    }

    return ids
}
